/* eslint-disable no-magic-numbers */

import {
	dimensions,
	filesize,
	aspectRatioRange,
	duration
} from "widgets/forms/validators/Assets";
import { requiredAsset, validateUnlessExternalRender, requiredAfterEffectsComp } from "social/validators/validators";
import {
	isURL,
	maxLength,
	requiredNotNull
} from "widgets/forms/validators/validators";
import { uniquePACVariableName } from "widgets/social2/validators/utils";

import {
	MAX_VIDEO_BYTES,
	MAX_THUMBNAIL_BYTES,
	MIN_VIDEO_SEC,
	MAX_VIDEO_MIN
} from "./consts";

export const staticValidators = {
	video: [uniquePACVariableName],
	thumbnail: [uniquePACVariableName],
	primaryText: [uniquePACVariableName],
	landingPage: [uniquePACVariableName],
};

export const validators = {
	afterEffectsComposition: [
		requiredAfterEffectsComp
	],
	video: validateUnlessExternalRender([
		requiredAsset,
		filesize({ max: MAX_VIDEO_BYTES }),
		dimensions({ minWidth: 250 }),
		aspectRatioRange(9 / 16, 1.91, 0.01, { min: "9:16", max: "1.91:1" }),
		duration({ min: MIN_VIDEO_SEC, max: MAX_VIDEO_MIN * 60 }),
	]),
	thumbnail: validateUnlessExternalRender([
		filesize({ max: MAX_THUMBNAIL_BYTES }),
	]),
	primaryText: [
		maxLength(2200),
	],
	landingPage: [
		requiredNotNull,
		isURL,
	],
};
